import { StyleSheet, type TextStyle } from 'react-native';
import { darkTheme } from '../../../src/theme/themes';

export const customizerToastStyles = StyleSheet.create({
  toastWrap: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 24,
    alignItems: 'center',
    zIndex: 40,
  },
  toast: {
    overflow: 'hidden',
    color: darkTheme.onPrimary,
    fontWeight: '700',
    fontSize: 13.5,
    paddingHorizontal: 18,
    paddingVertical: 11,
    borderRadius: 9999,
  },
});

export function getToastFillStyle(color: string): TextStyle {
  return { backgroundColor: color };
}
